/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: userActions.js
 *
 * Created by robertcaslin.
 */

export const ACCOUNT_CREATE_START    = "ACCOUNT_CREATE_START";
export const ACCOUNT_CREATE_SUCCESS = "ACCOUNT_CREATE_SUCCESS";
export const ACCOUNT_CREATE_ERROR    = "ACCOUNT_CREATE_ERROR";

export function accountCreateStart(creds) {
    return {
        type: ACCOUNT_CREATE_START,
        isFetching: true,
        isAuthenticated: false,
        creds

    };
}
export function accountCreateSuccess(user) {
    return {
        type: ACCOUNT_CREATE_SUCCESS,
        isFetching:false,
        isAuthenticated:true,
        token: user.auth_token,
        user
    };
}
export function accountCreateError(message) {
    return {
        type: ACCOUNT_CREATE_ERROR,
        isFetching:false,
        isAuthenticated:false,
        message
    };
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js